var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBluePnkGradient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 927,
    height: 815,
    viewBox: "0 0 927 815",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_225_925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.961 747.459C346.999 688.827 383.033 593.333 379.795 514.048C369.481 261.573 -118.44 476.97 -218.162 695.91C-303.028 882.233 -382.979 1256.15 -193.792 1277.67C-73.8178 1291.31 54.9007 1251.06 103.083 1129.54C131.681 1057.42 116.312 936.837 157.369 873.474C189.486 823.908 267.825 794.242 302.961 747.459Z",
    fill: "#FFDEDA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_225_925)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 258.5,
    cy: 1045.5,
    rx: 268.5,
    ry: 376.5,
    fill: "url(#paint0_linear_225_925)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_225_925",
    x: -709.771,
    y: 0.18634,
    width: 1489.77,
    height: 1680.02,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    result: "effect1_foregroundBlur_225_925"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_225_925",
    x: -410,
    y: 269,
    width: 1337,
    height: 1553,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    result: "effect1_foregroundBlur_225_925"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_225_925",
    x1: 258.5,
    y1: 669,
    x2: 258.5,
    y2: 1422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BB5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1FBFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePnkGradient);
export default __webpack_public_path__ + "static/media/bluePnkGradient.c96cdc20b6a46160182cc75242dfcb9b.svg";
export { ForwardRef as ReactComponent };